// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4002":"css/app.6992","5511":"css/admin-app.6992"}[chunkId] + ".css";
};